export const generateJSONData = (state, otherInfo) => {
  const browserName = (function (agent) {
    switch (true) {
      case agent.indexOf("edge") > -1:
        return "MS Edge";
      case agent.indexOf("edg/") > -1:
        return "Edge -  chromium based";
      case agent.indexOf("opr") > -1 && !!window.opr:
        return "Opera";
      case agent.indexOf("chrome") > -1 && !!window.chrome:
        return "Chrome";
      case agent.indexOf("trident") > -1:
        return "MS IE";
      case agent.indexOf("firefox") > -1:
        return "Mozilla Firefox";
      case agent.indexOf("safari") > -1:
        return "Safari";
      default:
        return "other";
    }
  })(window.navigator.userAgent.toLowerCase());
  const isMobile = window.navigator.userAgentData.mobile;
  const topic = window.location.hostname + " ";
  const windowSize = window.innerWidth;
  const driverViolation = state.options.enums
    .find((item) => item.name === "Driver Violation")
    ["enum"]["state"][state.stateCode].find(
      (item) => Number(state.accidentsOrTickets) === item.id
    )["name"];
  const driverOccupation = state.options.enums
    .find((item) => item.name === "Occupation")
    ["enum"]["state"][state.stateCode].find(
      (item) => Number(state.industry) === item.id
    )["name"];
  const driverAuto = state.options.enums
    .find((item) => item.id === 1002)
    ["enum"]["state"][state.stateCode].find(
      (item) => Number(state.mainVehicle) === item.id
    )["name"];
  const driverGaraging = state.overnightZipCode;
  // const driverAge = state.options.enums
  //   .find((item) => item.name === "Driver Age")
  //   ["enum"]["state"][state.stateCode].find(
  //     (item) => Number(state.ageDriver) === item.id
  //   )["name"];
  const driverUsage = state.options.enums
    .find((item) => item.name === "Usage")
    ["enum"]["state"][state.stateCode].find(
      (item) => Number(state.usage) === item.id
    )["name"];
  const driverTotalVehicles = state.options.enums
    .find((item) => item.name === "Number of Vehicles")
    ["enum"]["state"][state.stateCode].find(
      (item) => Number(state.totalVehicles) === item.id
    )["name"];
  const driverLiabilityLimits = state.options.enums
    .find((item) => item.name === "Liability Limits")
    ["enum"]["state"][state.stateCode].find(
      (item) => Number(state.liabilityLimits) === item.id
    )["name"];

  const data = {
    data: {
      monthly: {
        Average: otherInfo.monthly.normal,
        Excellent: otherInfo.monthly.pesimistic,
        Fair: otherInfo.monthly.optimistic,
      },
      annual: {
        Average: otherInfo.annual.normal,
        Excellent: otherInfo.annual.pesimistic,
        Fair: otherInfo.annual.optimistic,
      },
    },
    contact_info: {
      first_name: state.firstName,
      last_name: state.lastName,
      company_name: state.businessName,
      email: state.businessEmail,
      zip_postal_code: state.zipCode,
      business_phone: state.businessPhone,
    },
    estimate: {
      usage: driverUsage,
      number_of_vehicles: driverTotalVehicles,
      driver_violation: driverViolation,
      driver_age: state.ageDriver ? Number(state.ageDriver) : null,
      garaging_state: state.stateCode,
      liability_limits: driverLiabilityLimits,
      estimates: {
        monthly: {
          Average: otherInfo.monthly.normal,
          Excellent: otherInfo.monthly.pesimistic,
          Fair: otherInfo.monthly.optimistic,
        },
        annual: {
          Average: otherInfo.annual.normal,
          Excellent: otherInfo.annual.pesimistic,
          Fair: otherInfo.annual.optimistic,
        },
      },
      est_value: state.estimatedValueVehicle,
      occupation: driverOccupation,
      created_on: 1674145319,
      auto_model: driverAuto,
      lead_id: "abc",
      garaging_zip: driverGaraging,
    },
    device_source: {
      browser: browserName,
      device_type: "",
      screen_size: `${windowSize}px`,
      mobile_or_desktop: isMobile ? "mobile" : "desktop",
      topic: topic,
    },
  };

  return data;
};
